import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { generateTemplate } from "configs/utils/Excel";
import { DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss } from "constants/DateConstant";
import dayjs from 'dayjs';




export const upsertLetakMahasiswa =
	createAsyncThunk("mahasiswa/upsertLetakMahasiswa",
											 async (payload, { rejectWithValue }) => {
												 try {
													 const token = await localStorage.getItem('auth_token');
													 jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
													 const response = await jwtAuthAxios.post('v1/letak-kampus-mhs/upsert', payload);
													 return response.data;
												 } catch (e) {
													 rejectWithValue({
																		 message: e.data.message || e.message
																	 })
												 }
											 }
);

export const findAllLetakMhsMapping = createAsyncThunk("mahasiswa/findAllLetakMhsMapping",
												async (_, { rejectWithValue }) => {
													try {
														const token = await localStorage.getItem('auth_token');
														jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
														//const response = await jwtAuthAxios.get('v1/mahasiswa');
														const response = await jwtAuthAxios.get('v1/letak-kampus-mhs');
														return response.data;
													} catch (e) {
														rejectWithValue({
																			message: e.data.message || e.message
																		})
													}
												}
);

export const getAllMahasiswa = createAsyncThunk("mahasiswa/getAllMahasiswa",
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			//const response = await jwtAuthAxios.get('v1/mahasiswa');
			const response = await jwtAuthAxios.get('v1/master/mahasiswa');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);
/*

export const getMasterMahasiswa = createAsyncThunk("mahasiswa/getMasterMahasiswa",
	async ({page, pageSize, search}, { rejectWithValue }) => {
		console.log(search)
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = search 
			? `v1/master/mahasiswa/pageable?page=${page}&size=${pageSize}&search=namaMahasiswa~${search}` 
			: `v1/master/mahasiswa/pageable?page=${page}&size=${pageSize}&search=${search}`;
			const response = await jwtAuthAxios.get(url);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);
*/

export const getMasterMahasiswa = createAsyncThunk("mahasiswa/getMasterMahasiswa",
	async({ page, pageSize, search }, thunkAPI) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const searchParams = search === undefined ? "" : search;
			//const url = `v1/mata-kuliah/pageable?page=${page}&size=${pageSize}&search=${searchParams}`
			const url = `v1/master/mahasiswa/pageable?page=${page}&size=${pageSize}&search=${searchParams}`
			const response = await jwtAuthAxios.get(url)
			return response.data
		} catch(response){
			throw response
		}
	});

export const getMasterMahasiswaView = createAsyncThunk("mahasiswa/getMasterMahasiswaView",
	async({ page, pageSize, search, q, angkatan, idProdi, statusKrs }, thunkAPI) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			// filter: q = teks (NIM/nama/NIK/NISN), angkatan = kode periode, idProdi & statusKrs = array (dikirim dipisah koma)
			const params = new URLSearchParams({ page, size: pageSize, search: search === undefined ? "" : search });
			if (q) params.set('q', q);
			if (angkatan) params.set('angkatan', angkatan);
			if (idProdi?.length) params.set('id_prodi', idProdi.join(','));
			if (statusKrs?.length) params.set('status_krs', statusKrs.join(','));
			const url = `v1/master/mahasiswa/view/pageable?${params.toString()}`
			const response = await jwtAuthAxios.get(url)
			return response.data
		} catch(response){
			throw response
		}
	});

export const getAllMahasiswaPage = createAsyncThunk("mahasiswa/getAllMahasiswaPage",
	async ({ page, pageSize, search }, { rejectWithValue }) => {
		try {
			const token = localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(
				`v1/mahasiswa/pageable?page=${page}&size=${pageSize}&search=${search}`
			);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getBiodataMahasiswa = createAsyncThunk("mahasiswa/getBiodataMahasiswa",
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/master/mahasiswa');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getListMahasiswa = createAsyncThunk("mahasiswa/getListMahasiswa",
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/mahasiswa/detail/all');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getMahasiswaById = createAsyncThunk("mahasiswa/getMahasiswaById",
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/biodata-mahasiswa/${id}`);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const findMahasiswaByNim = createAsyncThunk("mahasiswa/findMahasiswaByNim",
												 async (id, { rejectWithValue }) => {
													 try {
														 const token = await localStorage.getItem('auth_token');
														 jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
														 const response = await jwtAuthAxios.post(`v1/biodata-mahasiswa/nim`,id);
														 return response.data;
													 } catch (e) {
														 rejectWithValue({
																			 message: e.data.message || e.message
																		 })
													 }
												 }
);


export const getBiodataMahasiswaById = createAsyncThunk("mahasiswa/getBiodataMahasiswaById",
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/master/mahasiswa/${id}`);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getMahasiswaByNim = createAsyncThunk("mahasiswa/getMahasiswaByNim",
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/mahasiswa/filter/detail?nim=${id}`);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getMahasiswaInfoByNim = createAsyncThunk("mahasiswa/getMahasiswaInfoByNim",
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/v/mahasiswa/info/${id}`);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const findByIdMhs = createAsyncThunk("mahasiswa/findByIdMhs",
	async (val, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.post(`v1/master/mahasiswa/id-mhs`,val);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getAyahById = createAsyncThunk("mahasiswa/getAyahById",
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/biodata-ortu/${id}`);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getIbuById = createAsyncThunk("mahasiswa/getIbuById",
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/biodata-ortu/${id}`);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const deleteMahasiswa = createAsyncThunk("mahasiswa/deleteMahasiswa",
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			await jwtAuthAxios.delete(`v1/biodata-mahasiswa/${id}`);
			return id;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const addMahasiswa = createAsyncThunk("mahasiswa/addMahasiswa",
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.post('v1/biodata-mahasiswa', payload);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const findByNim = createAsyncThunk("mahasiswa/findByNim",
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.post('v1/biodata-mahasiswa/nim', payload);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const updateMahasiswa = createAsyncThunk("mahasiswa/updateMahasiswa",
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.put('v1/biodata-mahasiswa', payload);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const downloadTemplateExcel = createAsyncThunk("mahasiswa/downloadTemplateExcel",
	async (payload, { rejectWithValue }) => {
		try {
			const workbook = await generateTemplate(payload);

			// Save to blob
			const buffer = await workbook.xlsx.writeBuffer();
			const blob = new Blob([buffer], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			const url = URL.createObjectURL(blob);

			// Create a temporary link element
			const link = document.createElement('a');
			link.href = url;
			link.download = 'mahasiswa_data.xlsx';

			// Trigger a click on the link to initiate the download
			link.click();

			// Cleanup
			URL.revokeObjectURL(url);
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const createMahasiswa = createAsyncThunk("mahasiswa/createMahasiswa",
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.post('/v1/master/mahasiswa', payload);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

const biodata = {
	namaLengkap: '',
	nik: '',
	jenisKelamin: '',
	tempatLahir: '',
	tanggalLahir: dayjs('1980-01-01', DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss),
	agama: '',
	kewarganegaraan: '',
	alamat: '',
	rt: '',
	rw: '',
	kelurahan: '',
	kecamatan: '',
	kabupaten: '',
	provinsi: '',
	kodepos: '',
	teleponRumah: '',
	email: '',
	handphone: ''
};

const mahasiswaBiodata = {
	nisn: '',
};

const ortuBiodata = {
	npwp: '',
	jenjangPendidikan: '',
	pekerjaan: '',
	penghasilan: ''
}

const pagination = {
	page: 1,
	pageSize: 10,
	pageSizeOptions: ['10', '20', '30', '50'],
	total: null,
}

const initialState = {
	data:{},
	loading:false,
	info_mahasiswa:{},
	upsertData:{},
	mapMhsList:[],
	masterMahasiswaView:[],
	masterMahasiswa:[],
	biodataMahasiswa: [],
	biodata_mahasiswa:{},
	allMahasiswa: [],
	listMahasiswa: [],
	filterByNim: [],
	pageMahasiswa: [],
	totalPages: 0,
	single: {
		biodata_mahasiswa: {
			...biodata,
			...mahasiswaBiodata,
		},
		biodata_ayah: {
			...biodata,
			...ortuBiodata,
		},
		biodata_ibu: {
			...biodata,
			...ortuBiodata
		}
	},
	pagination: {
		allMahasiswa: {
			...pagination
		}
	},
	steps: {
		current: 0
	},
	status: {
		loading: false
	}
}

const mahasiswaSlice = createSlice({
	name: "mahasiswa",
	initialState,
	reducers: {
		onRefreshForm: (state) => {
			state.single = initialState.single
			state.status = initialState.status;
		},
		onRefreshStatus: (state) => {
			state.status = initialState.status;
		},
		onRefreshSteps: (state) => {
			state.steps.current = 0;
		},
		onChangeData: (state, action) => ({
			...state,
			...action.payload
		}),
		onChangePagination: (state, action) => {
			const { paginationName, pageChange, pageSizeChange, totalChange } = action.payload;
			state.pagination[paginationName] = {
				...state.pagination[paginationName],
				page: state.pagination[paginationName].pageSize !== pageSizeChange ? 1 : pageChange,
				pageSize: pageSizeChange,
				total: totalChange,
			}
		},
		nextStep: (state) => {
			state.steps.current++;
		},
		prevStep: (state) => {
			state.steps.current--;
		},
	},
	extraReducers: {


		[getMahasiswaInfoByNim.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getMahasiswaInfoByNim.fulfilled]: (state, action) => {
			state.info_mahasiswa = action.payload.data;
			state.status.loading = false;
		},
		[getMahasiswaInfoByNim.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[findMahasiswaByNim.pending]: (state, action) => {
			state.status.loading = true;
		},
		[findMahasiswaByNim.fulfilled]: (state, action) => {
			state.biodata_mahasiswa = action.payload;
			state.status.loading = false;
		},
		[findMahasiswaByNim.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getAllMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getAllMahasiswa.fulfilled]: (state, action) => {
			state.allMahasiswa = action.payload;
			state.status.loading = false;
		},
		[getAllMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[upsertLetakMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[upsertLetakMahasiswa.fulfilled]: (state, action) => {
			state.upsertData = action.payload;
			state.status.loading = false;
		},
		[upsertLetakMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},


		[getMasterMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getMasterMahasiswa.fulfilled]: (state, action) => {
			state.masterMahasiswa = action.payload;
			state.status.loading = false;
		},
		[getMasterMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getMasterMahasiswaView.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getMasterMahasiswaView.fulfilled]: (state, action) => {
			state.masterMahasiswaView = action.payload;
			state.status.loading = false;
		},
		[getMasterMahasiswaView.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[findAllLetakMhsMapping.pending]: (state, action) => {
			state.status.loading = true;
		},
		[findAllLetakMhsMapping.fulfilled]: (state, action) => {
			state.mapMhsList = action.payload;
			state.status.loading = false;
		},
		[findAllLetakMhsMapping.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getAllMahasiswaPage.pending]: (state) => {
            state.status.loading = true;
        },
        [getAllMahasiswaPage.fulfilled]: (state, action) => {
            const { result, page } = action.payload?.data;
			const { number, size, totalElements } = page;
            state.allMahasiswa = result;
            state.pagination.allMahasiswa = {
                ...state.pagination.allMahasiswa,
                page: state.pagination.allMahasiswa.pageSize !== size ? 1 : number + 1,
                pageSize: size,
                total: totalElements,
            }
            state.status.loading = false;
        },
        [getAllMahasiswaPage.rejected]: (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        },

		[getBiodataMahasiswa.pending]: (state) => {
			state.status.loading = true;
		},
		[getBiodataMahasiswa.fulfilled]: (state, action) => {
			state.biodataMahasiswa = action.payload;
			state.status.loading = false;
		},
		[getBiodataMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[findByNim.pending]: (state) => {
			state.status.loading = true;
		},
		[findByNim.fulfilled]: (state, action) => {
			state.biodataMahasiswa = action.payload;
			state.status.loading = false;
		},
		[findByNim.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getListMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getListMahasiswa.fulfilled]: (state, action) => {
			state.listMahasiswa = action.payload;
			state.status.loading = false;
		},
		[getListMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getMahasiswaById.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getMahasiswaById.fulfilled]: (state, action) => {
			state.single.biodata_mahasiswa = action.payload;
			state.status.loading = false;
		},
		[getMahasiswaById.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getBiodataMahasiswaById.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getBiodataMahasiswaById.fulfilled]: (state, action) => {
			state.biodata_mahasiswa = action.payload;
			state.status.loading = false;
		},
		[getBiodataMahasiswaById.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getMahasiswaByNim.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getMahasiswaByNim.fulfilled]: (state, action) => {
			state.filterByNim = action.payload;
			state.status.loading = false;
		},
		[getMahasiswaByNim.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getAyahById.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getAyahById.fulfilled]: (state, action) => {
			state.single.biodata_ayah = action.payload;
			state.status.loading = false;
		},
		[getAyahById.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[getIbuById.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getIbuById.fulfilled]: (state, action) => {
			state.single.biodata_ibu = action.payload;
			state.status.loading = false;
		},
		[getIbuById.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[addMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[addMahasiswa.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[addMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[createMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[createMahasiswa.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[createMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[deleteMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[deleteMahasiswa.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[deleteMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[updateMahasiswa.pending]: (state, action) => {
			state.status.loading = true;
		},
		[updateMahasiswa.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[updateMahasiswa.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[downloadTemplateExcel.pending]: (state, action) => {
			state.status.loading = true;
		},
		[downloadTemplateExcel.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[downloadTemplateExcel.rejected]: (state, action) => {
			state.status.loading = false;
		},

		[findByIdMhs.pending]: (state, action) => {
			state.loading = true;
		},
		[findByIdMhs.fulfilled]: (state, action) => {
			state.data = action.payload;
			state.loading = false;
		},
		[findByIdMhs.rejected]: (state, action) => {
			state.loading = false;
		},
	}
})

export const {
	onRefreshForm,
	onRefreshStatus,
	onChangeData,
	nextStep,
	prevStep,
	onRefreshSteps
} = mahasiswaSlice.actions;

export const selectMahasiswa = (state) => state.mahasiswa;

export default mahasiswaSlice.reducer;
